import { defaultIconProps, IconProps } from './IconProps';

export const IconChevronLeft: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M12.5 15L7.5 10L12.5 5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconChevronLeft.defaultProps = defaultIconProps;
